import React, { useState } from 'react';
import {blockTypeOptions} from '../models';
import {ListGroup, ListGroupItem, ButtonToolbar, Button, Glyphicon, Modal} from 'react-bootstrap';

import './block-list.scss';

const BlocksList = ({blocks = [], onEdit, onDelete, onPreview}) => {
    const [isDeleteConfirmVisible, setIsDeleteConfirmVisible] = useState(false);
    const [removableBlock, setRemovableBlock] = useState(null);
    
    function handleConfirmDelete(block) {
        setIsDeleteConfirmVisible(true);
        setRemovableBlock(block);
    }

    function handleRemove() {
        onDelete(removableBlock);
        setIsDeleteConfirmVisible(false);
    }

    return (
        <>
            <ListGroup className="mail-block-list">
                {
                    blocks.map((block, index) => (
                        <ListGroupItem key={index}>
                            <div className='mail-block-list-item'>
                                <div className='mail-block-list-item__info'>
                                    <div>
                                        <p><strong>Тип блока</strong></p>
                                        <h5>
                                            {blockTypeOptions[block.type]}
                                        </h5>
                                    </div>
                                    <div>
                                        <p><strong>Название блока</strong></p>
                                        <h5>
                                            {block.name}
                                        </h5>
                                    </div>
                                </div>
                                <ButtonToolbar>
                                    <Button
                                        bsStyle="success"
                                        onClick={() => onEdit(block)}
                                    >
                                        <Glyphicon glyph="edit" />
                                    </Button>
                                    <Button onClick={() => onPreview(block)}>
                                        <Glyphicon glyph="eye-open" />
                                    </Button>
                                    <Button
                                        disabled={block.defaultBlock}
                                        onClick={() => handleConfirmDelete(block)}
                                    >
                                        <Glyphicon glyph="trash" />
                                    </Button>
                                </ButtonToolbar>
                            </div>
                        </ListGroupItem>
                    ))
                }
            </ListGroup>
            <Modal show={isDeleteConfirmVisible}>
                <Modal.Header>
                    <Modal.Title>
                        Удалить блок <strong>{removableBlock ? removableBlock.name : ''}</strong>?
                    </Modal.Title>
                </Modal.Header>
                <Modal.Footer>
                    <Button
                        bsStyle="danger"
                        onClick={() => handleRemove()}
                    >
                        Удалить
                    </Button>
                    <Button onClick={() => setIsDeleteConfirmVisible(false)}>
                        Отмена
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
};

export default BlocksList;
